module.exports = __webpack_public_path__ + "img/1727166089934-14ae89c0-1a69-4be2-a165-9d1b9796483e 1.jpeg.3bb13c17.webp";